import { clsx } from "clsx";
import { Text } from "../typography";

type UserAvatarSize = "sm" | "md" | "lg";

interface UserAvatarProps {
  initials: string;
  size?: UserAvatarSize;
  className?: string;
}

const SIZE_CLASS: Record<UserAvatarSize, string> = {
  sm: "size-8 rounded-full",
  md: "size-10 rounded-full",
  lg: "size-12 rounded-full",
};

const TEXT_VARIANT: Record<UserAvatarSize, "bodyXsBold" | "bodySmBold" | "bodyLgBold"> = {
  sm: "bodyXsBold",
  md: "bodySmBold",
  lg: "bodyLgBold",
};

export function UserAvatar({ initials, size = "sm", className }: UserAvatarProps) {
  return (
    <span
      className={clsx(
        "inline-flex items-center justify-center bg-textBody",
        SIZE_CLASS[size],
        className,
      )}
    >
      <Text variant={TEXT_VARIANT[size]} inline className="text-white">
        {initials}
      </Text>
    </span>
  );
}

export default UserAvatar;
